module.exports = __webpack_public_path__ + "static/img/rank_192.f97f173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_192.png
// module id = PJJL
// module chunks = 1